import React from "react";
import NightShiftNav from "../../pages/Dashboard/NightShift/NightShiftNav";
import NightShiftSchedule from "../../pages/Dashboard/NightShift/NightShiftSchedule";

const nightShiftRoutes = {
  path: "/night-shift",
  element: <NightShiftNav />,
  children: [
    { path: "/night-shift", element: <NightShiftSchedule /> },
    { path: "/night-shift/schedule", element: <NightShiftSchedule /> },
  ],
};

export default nightShiftRoutes;
